import { Colors, typographyStyle } from '@revenuemarket/design';
import { Typography } from 'antd';
import { MenuItemGroupType } from 'rc-menu/lib/interface';

import { CategoryTreeItem } from '~apis/categories';
import { FlattenTreeResult } from '~components/ui/HorizontalTreeTable/Table';
import { useTransactionRecommendedLabel } from '~hooks/queries/transactions/query';
import { useDemoAwareCompanyId } from '~hooks/useDemoAwareCompanyId';

const useRecommendLabelOptions = ({
  activeKey,
  accountId,
  transactionId,
  treeList = [],
}: {
  activeKey: string[] | null;
  accountId?: number;
  transactionId?: number;
  treeList: FlattenTreeResult<CategoryTreeItem>[];
}) => {
  const { companyId } = useDemoAwareCompanyId();
  const { data: recommendedLabelResponse } = useTransactionRecommendedLabel({
    companyId,
    accountId: accountId,
    transactionId: transactionId,
  });

  const recommendLabels =
    recommendedLabelResponse?.Data?.data?.recommendations
      ?.map((item) => {
        const target = treeList.find(
          (node) => node.value?.categoryLabelKey === item.categoryLabelKey,
        );
        if (!target) {
          return null;
        }

        return {
          key: target?.key,
          label: (
            <Typography.Text style={{ ...typographyStyle['14_400'], color: Colors.gray700 }}>
              {target?.value?.name}
            </Typography.Text>
          ),
        };
      })
      .filter((i) => {
        return !activeKey?.includes(i?.key ?? '');
      })
      .filter(Boolean) ?? [];

  const recommendLabelOptions =
    recommendLabels?.length > 0
      ? [
          {
            type: 'group',
            label: (
              <Typography.Text style={{ ...typographyStyle['14_400'], color: Colors.gray400 }}>
                클로브 추천
              </Typography.Text>
            ),

            children: recommendLabels,
          } as MenuItemGroupType,
          {
            type: 'divider' as const,
          },
        ]
      : [];

  return recommendLabelOptions;
};

export default useRecommendLabelOptions;
